import React from 'react';
import styled from 'styled-components';
import { colors, Heading, Button, Paragraph } from '@telia/styleguide';
import { Product } from '../../types';
import { MediaQueries } from '../../util/MediaQueries';
import AppleTVImg from '../../assets/appletv.png';
import { AppleTvCPID, OpptakCPID } from '../../util/utils';
interface Props {
  product: Product;
  description: string;
  onSelect: () => void;
  selected: boolean;
}

const AdditionalProduct: React.FC<Props> = ({ product, onSelect, description, selected }) => {
  const hasOffer = product.adjustedRecurringCharge < product.recurringCharge;
  const isAppleTV = product.commercialProductId === AppleTvCPID;
  const getOfferText = (product: Product) => {
    if (product.commercialProductId === OpptakCPID) {
      return `${product.recurringCharge},- / md. etter 12 måneder`;
    }
    return `${product.recurringCharge},- / md. etter kampanje`;
  };

  return (
    <Container>
      <NameContainer>
        <Heading tag="h2" size="l" text={product.name} style={{ color: '#990AE3' }} />
      </NameContainer>
      <ImageContainer>{isAppleTV && <img src={AppleTVImg} alt="Apple-tv" />}</ImageContainer>
      <Prices>
        <PriceContainer>
          <Price>{product.adjustedRecurringCharge},-</Price>
          <ChargePeriod>Månedspris</ChargePeriod>
        </PriceContainer>
        <PriceContainer>
          <Price>{product.adjustedEstablishmentFee},-</Price>
          <ChargePeriod>Etablering</ChargePeriod>
        </PriceContainer>
      </Prices>
      <DescriptionAndEstablishment>
        {hasOffer && <ChargePeriod>{getOfferText(product)}</ChargePeriod>}
        <Paragraph>{description}</Paragraph>
      </DescriptionAndEstablishment>
      <ButtonContainer>
        <Button text={selected ? 'Lagt til' : 'Legg til'} kind={selected ? 'inverted' : 'normal'} onClick={onSelect} />
      </ButtonContainer>
    </Container>
  );
};

export default AdditionalProduct;
const ImageContainer = styled.div`
  img {
    width: 300px;
    object-fit: cover;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border: 1px solid ${colors.grey500};
  margin: 1rem 1rem;
  padding: 0 1.5rem 0 1.5rem;
  ${MediaQueries.desktop} {
    min-width: 400px;
  }
  ${MediaQueries.notDesktop} {
    min-width: 300px;
  }
  padding: 0.5rem;
`;

const NameContainer = styled.div``;

const Prices = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-right: 1rem;
`;

const ChargePeriod = styled.p`
  margin: 0;
`;

const Price = styled.p`
  margin: 0;
  font-family: Pebble;
  font-size: 2.25rem;
`;

const DescriptionAndEstablishment = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 350px;
  font-size: 1.25rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
`;
